




// @ is an alias to /src
import { AloPlat } from '@/models/alo/AloPlat'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import BasePlat from '@/components/carte/BasePlat'

@Component({
  name: 'Allergenes'
})
export default class Allergenes extends mixins(BasePlat) {  

  get allergenesDic(){
    return this.$store.myGetters.allergenesDic
  }

  get showAllergene(){
    return this.$store.myGetters.showAllergene
  }
}
